import { Loader2 } from 'lucide-react';
import { memo } from 'react';

interface LoadingOverlayProps {
  isActive: boolean;
  message?: string;
  subMessage?: string;
}

/**
 * LoadingOverlay component displays a centered loading indicator with messages
 *
 * Performance optimizations:
 * - Memoized component to prevent unnecessary re-renders
 * - Early return for inactive state to avoid rendering hidden elements
 * - Simplified DOM structure
 */
const LoadingOverlay = memo(
  ({
    isActive,
    message = 'جاري حفظ الطلب...',
    subMessage = 'يرجى الانتظار قليلاً',
  }: LoadingOverlayProps) => {
    // Don't render anything if not active
    if (!isActive) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
        <div className="rounded-xl bg-white p-6 shadow-xl dark:bg-slate-800">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="h-12 w-12 animate-spin text-primary" />
            {message && <div className="text-lg font-semibold">{message}</div>}
            {subMessage && (
              <div className="text-sm text-muted-foreground">{subMessage}</div>
            )}
          </div>
        </div>
      </div>
    );
  },
);

// Add display name for better debugging in React DevTools
LoadingOverlay.displayName = 'LoadingOverlay';

export default LoadingOverlay;
